<template lang="html">
  <div  :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      :fixed="true"
      title="我赞过的评论"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <CommentList
      :i-like="true"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import CommentList from '../../comment-list.vue'
  Vue.use(NavBar)
  export default {
    inject: ['reload'],
    components: {
      CommentList
    },
    data () {
      return {
        slug: '',
        offsetHeight: 0
      }
    },
    methods: {
      onClickLeft() {
        this.$router.replace({
          name: `PersonalIndex`,
          params: {
            slug: this.slug
          }
        })
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.$nextTick(function() {
        // this.offsetHeight = this.$refs.navBar.offsetHeight
        this.offsetHeight = this.$refs.navBar.$el.offsetHeight
      })
    },
    activated () {
      window.console.log("重新载入111")
    },
    deactivated () {
      window.console.log('About has been deactivated')
    }
  }
</script>

<style lang="css" scoped>
</style>
